'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherRefreshCw } from '@subframe/core';
import { useEffect, useState } from 'react';
import { Button, CurrencyInput, Dialog, TextArea, TextField } from '@/shared/components/ui';
import type { Fatura } from '../types';
import { dataAtualISO, formatarDataCurta, formatarMoedaBR } from '../utils/faturaFormatters';
const MIN_MOTIVO = 10;
interface ReemitirFaturaModalProps {
  isOpen: boolean;
  fatura: Fatura | null;
  saving: boolean;
  onClose: () => void;
  onConfirm: (data: {
    valor: number;
    dataVencimento: string;
    descricao: string;
    motivo: string;
  }) => void;
}
export function ReemitirFaturaModal(t0) {
  const $ = _c(79);
  const {
    isOpen,
    fatura,
    saving,
    onClose,
    onConfirm
  } = t0;
  const [valor, setValor] = useState(0);
  const [vencimento, setVencimento] = useState("");
  const [descricao, setDescricao] = useState("");
  const [motivo, setMotivo] = useState("");
  let t1;
  let t2;
  if ($[0] !== fatura || $[1] !== isOpen) {
    t1 = () => {
      if (isOpen && fatura) {
        setValor(fatura.valorTotal);
        setVencimento(fatura.dataVencimento.slice(0, 10));
        setDescricao(fatura.descricao);
        setMotivo("");
      }
    };
    t2 = [isOpen, fatura];
    $[0] = fatura;
    $[1] = isOpen;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  if (!fatura) {
    return null;
  }
  let t3;
  if ($[4] !== motivo) {
    t3 = motivo.trim();
    $[4] = motivo;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const motivoValido = t3.length >= MIN_MOTIVO;
  const valorValido = valor > 0;
  const vencimentoValido = vencimento >= dataAtualISO();
  let t4;
  if ($[6] !== descricao) {
    t4 = descricao.trim();
    $[6] = descricao;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const descricaoValida = t4.length >= 10;
  let t5;
  if ($[8] !== descricao || $[9] !== fatura.dataVencimento || $[10] !== fatura.descricao || $[11] !== fatura.valorTotal || $[12] !== valor || $[13] !== vencimento) {
    t5 = valor !== fatura.valorTotal || vencimento !== fatura.dataVencimento.slice(0, 10) || descricao !== fatura.descricao;
    $[8] = descricao;
    $[9] = fatura.dataVencimento;
    $[10] = fatura.descricao;
    $[11] = fatura.valorTotal;
    $[12] = valor;
    $[13] = vencimento;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const algumCampoAlterado = t5;
  const podeConfirmar = motivoValido && valorValido && vencimentoValido && descricaoValida && algumCampoAlterado && !saving;
  let t6;
  let t7;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="bg-brand-50 flex h-10 w-10 shrink-0 items-center justify-center rounded-full"><FeatherRefreshCw className="text-brand-600 h-5 w-5" /></div>;
    t7 = <h2 className="text-body-bold font-body-bold text-default-font">Reemitir fatura</h2>;
    $[15] = t6;
    $[16] = t7;
  } else {
    t6 = $[15];
    t7 = $[16];
  }
  let t8;
  if ($[17] !== fatura.numero || $[18] !== fatura.tenantNome) {
    t8 = <div className="flex items-start gap-3">{t6}<div>{t7}<p className="text-caption font-caption text-subtext-color mt-1">{fatura.tenantNome} · {fatura.numero}</p></div></div>;
    $[17] = fatura.numero;
    $[18] = fatura.tenantNome;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="flex items-start gap-2 rounded-[8px] bg-neutral-50 px-3 py-2 text-sm text-neutral-700">A fatura original será cancelada e uma nova será criada no lugar. As duas ficam vinculadas no histórico para auditoria.</div>;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = val => setValor(val);
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== fatura.valorTotal || $[23] !== valor) {
    t11 = valor !== fatura.valorTotal ? `Anterior: ${formatarMoedaBR(fatura.valorTotal)}` : undefined;
    $[22] = fatura.valorTotal;
    $[23] = valor;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t11 || $[26] !== valor) {
    t12 = <div className="flex flex-col gap-1.5"><CurrencyInput label="Valor *" value={valor} onChange={t10} helpText={t11} /></div>;
    $[25] = t11;
    $[26] = valor;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== fatura.dataVencimento || $[29] !== vencimento) {
    t13 = vencimento !== fatura.dataVencimento.slice(0, 10) ? `Anterior: ${formatarDataCurta(fatura.dataVencimento)}` : undefined;
    $[28] = fatura.dataVencimento;
    $[29] = vencimento;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = dataAtualISO();
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = e => setVencimento(e.target.value);
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== vencimento) {
    t16 = <TextField.Input type="date" min={t14} value={vencimento} onChange={t15} />;
    $[33] = vencimento;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== t13 || $[36] !== t16) {
    t17 = <div className="flex flex-col gap-1.5"><TextField label="Vencimento *" helpText={t13}>{t16}</TextField></div>;
    $[35] = t13;
    $[36] = t16;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== t12 || $[39] !== t17) {
    t18 = <div className="grid grid-cols-1 gap-4 md:grid-cols-2">{t12}{t17}</div>;
    $[38] = t12;
    $[39] = t17;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  let t19;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <label className="text-sm font-medium text-neutral-700">Descrição *</label>;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  let t20;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = e_0 => setDescricao(e_0.target.value);
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] !== descricao) {
    t21 = <div className="flex flex-col gap-1.5">{t19}<TextArea><TextArea.Input value={descricao} onChange={t20} rows={2} /></TextArea></div>;
    $[43] = descricao;
    $[44] = t21;
  } else {
    t21 = $[44];
  }
  let t22;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <label className="text-sm font-medium text-neutral-700">Motivo da reemissão *</label>;
    $[45] = t22;
  } else {
    t22 = $[45];
  }
  let t23;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = e_1 => setMotivo(e_1.target.value);
    $[46] = t23;
  } else {
    t23 = $[46];
  }
  let t24;
  if ($[47] !== motivo) {
    t24 = <div className="flex flex-col gap-1.5">{t22}<TextArea><TextArea.Input placeholder={"Por que est\xE1 reemitindo? (m\xEDn. 10 caracteres)"} value={motivo} onChange={t23} rows={2} /></TextArea></div>;
    $[47] = motivo;
    $[48] = t24;
  } else {
    t24 = $[48];
  }
  let t25;
  if ($[49] !== algumCampoAlterado) {
    t25 = !algumCampoAlterado && <p className="text-caption font-caption text-subtext-color">Altere ao menos um campo (valor, vencimento ou descrição) para reemitir.</p>;
    $[49] = algumCampoAlterado;
    $[50] = t25;
  } else {
    t25 = $[50];
  }
  let t26;
  if ($[51] !== onClose || $[52] !== saving) {
    t26 = <Button variant="neutral-secondary" size="medium" onClick={onClose} disabled={saving}>Cancelar</Button>;
    $[51] = onClose;
    $[52] = saving;
    $[53] = t26;
  } else {
    t26 = $[53];
  }
  let t27;
  if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <FeatherRefreshCw />;
    $[54] = t27;
  } else {
    t27 = $[54];
  }
  let t28;
  if ($[55] !== descricao || $[56] !== motivo || $[57] !== onConfirm || $[58] !== valor || $[59] !== vencimento) {
    t28 = () => onConfirm({
      valor,
      dataVencimento: vencimento,
      descricao: descricao.trim(),
      motivo: motivo.trim()
    });
    $[55] = descricao;
    $[56] = motivo;
    $[57] = onConfirm;
    $[58] = valor;
    $[59] = vencimento;
    $[60] = t28;
  } else {
    t28 = $[60];
  }
  const t29 = !podeConfirmar;
  let t30;
  if ($[61] !== saving || $[62] !== t28 || $[63] !== t29) {
    t30 = <Button variant="brand-primary" size="medium" icon={t27} onClick={t28} loading={saving} disabled={t29}>Confirmar reemissão</Button>;
    $[61] = saving;
    $[62] = t28;
    $[63] = t29;
    $[64] = t30;
  } else {
    t30 = $[64];
  }
  let t31;
  if ($[65] !== t26 || $[66] !== t30) {
    t31 = <div className="flex items-center justify-end gap-2 border-t border-neutral-100 pt-4">{t26}{t30}</div>;
    $[65] = t26;
    $[66] = t30;
    $[67] = t31;
  } else {
    t31 = $[67];
  }
  let t32;
  if ($[68] !== t18 || $[69] !== t21 || $[70] !== t24 || $[71] !== t25 || $[72] !== t31 || $[73] !== t8) {
    t32 = <Dialog.Content className="max-w-2xl"><div className="flex w-full flex-col gap-5 p-6">{t8}{t9}{t18}{t21}{t24}{t25}{t31}</div></Dialog.Content>;
    $[68] = t18;
    $[69] = t21;
    $[70] = t24;
    $[71] = t25;
    $[72] = t31;
    $[73] = t8;
    $[74] = t32;
  } else {
    t32 = $[74];
  }
  let t33;
  if ($[75] !== isOpen || $[76] !== onClose || $[77] !== t32) {
    t33 = <Dialog open={isOpen} onOpenChange={onClose}>{t32}</Dialog>;
    $[75] = isOpen;
    $[76] = onClose;
    $[77] = t32;
    $[78] = t33;
  } else {
    t33 = $[78];
  }
  return t33;
}